import { render, staticRenderFns } from "./NevronClickConfirm.vue?vue&type=template&id=032e63a2&"
import script from "./NevronClickConfirm.vue?vue&type=script&lang=js&"
export * from "./NevronClickConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports